// tslint:disable
export var CoveragedetEligibilityState;
(function (CoveragedetEligibilityState) {
    // Not yet set, or no matching state found.
    CoveragedetEligibilityState[CoveragedetEligibilityState["UNKNOWN"] = 0] = "UNKNOWN";
    // Eligible.
    CoveragedetEligibilityState[CoveragedetEligibilityState["ELIGIBLE"] = 1] = "ELIGIBLE";
    // Error.
    CoveragedetEligibilityState[CoveragedetEligibilityState["ERROR"] = 2] = "ERROR";
    // Invalid provider.
    CoveragedetEligibilityState[CoveragedetEligibilityState["INVALIDPROVIDER"] = 3] = "INVALIDPROVIDER";
    // NO MATCH
    CoveragedetEligibilityState[CoveragedetEligibilityState["NoMatch"] = 4] = "NoMatch";
    // NOT ELIG
    CoveragedetEligibilityState[CoveragedetEligibilityState["NotElig"] = 5] = "NotElig";
})(CoveragedetEligibilityState || (CoveragedetEligibilityState = {}));
CoveragedetEligibilityState['NOMATCH'] = 4;
CoveragedetEligibilityState['NOTELIG'] = 5;
//# sourceMappingURL=CoveragedetEligibilityState.js.map